<script lang="ts">
	import { setContext } from 'svelte';
	import List from '$lib/elements/List.svelte';
	import type { ListItemsProps } from '$lib/types/props';
	import MainNavAbout from './MainNavAbout.svelte';
	import MainNavCompanies from './MainNavCompanies.svelte';
	import MainNavInvestors from './MainNavInvestors.svelte';

	setContext('sublistsClass', 'main-nav__sublist');
	setContext('sublistsLabelClass', 'main-nav__sublist-label');

	let items: ListItemsProps = [
		{
			component: MainNavInvestors,
			props: {}
		},
		{
			component: MainNavCompanies,
			props: {}
		},
		{
			component: MainNavAbout,
			props: {}
		}
	];
</script>

<nav class="main-nav">
	<List
		{items}
		listStyle="none"
		itemsClassNames="pb-3 mb-3 lg:pb-0 lg:mb-0 relative lg:inline-block"
		classNames="main-nav__list mb-3 lg:mb-0 space-y-3 lg:space-y-0"
	/>
</nav>

<style lang="postcss">
	.main-nav {
		@apply w-full lg:w-auto relative lg:flex;

		& :global(.main-nav__list) {
			@apply lg:flex lg:items-start lg:justify-evenly lg:gap-6 xl:gap-7;
		}

		& :global(.main-nav__sublist) {
			@apply lg:hidden lg:absolute lg:overflow-hidden lg:transition-all lg:border-transparent lg:pt-2 lg:rounded-lg lg:min-w-[300px];
		}

		& :global(.main-nav__sublist .link) {
			@apply py-2;
		}

		& :global(.main-nav__sublist .link span) {
			@apply !flex items-center before:block before:w-0 before:h-1 before:rounded before:bg-primary before:transition-all;
		}

		& :global(.main-nav__sublist .selected),
		& :global(.main-nav__sublist .link:hover) {
			@apply text-primary font-medium;
		}

		& :global(.main-nav__sublist .selected span),
		& :global(.main-nav__sublist .link:hover span) {
			@apply before:mr-2 before:w-3;
		}

		& :global(.main-nav__sublist-label) {
			@apply font-bold lg:py-3;
		}

		& :global(.main-nav__list li:hover .main-nav__sublist) {
			@apply lg:block lg:bg-white lg:py-2 lg:px-4 lg:border lg:border-grey-light;
		}
	}
</style>
